import React                            from 'react';

import {ListItemData} from '../../ListItem';
import { MessageHandlerInterface } from '../../../../messages/MessageHandler';

import  "./Carousel.scss";
import { CarouselArrow  } from './ArrowsAndDots';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot, DotGroup } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { Config } from '../../../../Config/Config';
import { Dots } from '../../../../components/Dots/Dots';
import { ActionInterface, CarouselPayloadCard, createActionTaken, ActionTakenType } from '@swivl-mono/types';


const WIDTH_FACTOR = 0.8

export interface CarouselCardButtonProps {
  action:ActionInterface;
  isSelected:boolean;
  isDisabled:boolean;
  index:number;
  actionSelected:(item:ActionInterface)=>void;
}
class CarouselCardButton extends React.Component<CarouselCardButtonProps> {
  constructor(props:CarouselCardButtonProps) {
    super(props);
    this.onClick = this.onClick.bind(this)

  }
  onClick() {
    if (!Config.canPressButtons || this.props.isSelected || this.props.isDisabled) { return; }
    this.props.actionSelected(this.props.action);
  }
  render(){
    let className = "scc-CarouselCardButton";
    if (this.props.isSelected) { className += " scc-selected"; }
    if (this.props.isDisabled) {
       className += " scc-disabled";
    } else {
      if (this.props.index === 0) {  className += " swivl-primaryButton"; }
      if (this.props.index === 1) {  className += " swivl-secondaryButton"; }
      if (this.props.index === 2) {  className += " swivl-secondaryButton"; }
    }

    return <div
            className={className}
            onClick={this.onClick}>
              {this.props.action.text}
            </div>;
  }

}



export interface CarouselCardProps {
  item:CarouselPayloadCard;
  selectedId:string|undefined;
  width:number;
  actionSelected:(item:ActionInterface)=>void;
  isActive:boolean;

}
class CarouselCard extends React.Component<CarouselCardProps> {
  render(){
    const item = this.props.item;
    const style = {width:this.props.width+ "px", padding:"0 40px" }
    const cardWidth = this.props.width - 80;

    const cardStyle = {width:cardWidth + "px" }
    const image = (item.mediaURL && item.mediaURL.length > 1) ? <div className="scc-CarouselImage" style={{width:cardWidth+"px", height:(cardWidth*0.5625) + "px"}}><img src={item.mediaURL} width={cardWidth} height={cardWidth*0.5625} /></div>:null;
    const title = (item.title && item.title.length > 1) ? <div className="scc-CarouselTitle">{item.title}</div>:null;
    const description = (item.description && item.description.length > 1) ? <div className="scc-CarouselDescription">{item.description}</div>:null;
    const buttons = item.actions.map((action:ActionInterface, index:number) => {
      const isSelected = (this.props.selectedId && this.props.selectedId === action.id) ? true : false;
      const isDisabled = ((this.props.selectedId || !this.props.isActive) && !isSelected) ? true : false;
        return <CarouselCardButton
                key={action.id}
                index={index}
                action={action}
                isSelected={isSelected}
                isDisabled={isDisabled}
                actionSelected={this.props.actionSelected}
                />;
        }
  );

    const textSpacer = (title || description) ? <div className="scc-TextSpacer"/>:null;

    return  <div className="scc-CarouselCardWrapper" style={style}>
              <div className="scc-CarouselCard" style={cardStyle}>
                {image}
                {title}
                {description}
                {textSpacer}
                {buttons}
              </div>
            </div>
  }
}



export interface CarouselProps {
  item:ListItemData;
  messageHandler:MessageHandlerInterface;
  width:number;
  isActive:boolean;
}
export interface CarouselState {
  isAlreadySelected:boolean;
  trackIndex:number;
}



export class Carousel extends React.Component<CarouselProps, CarouselState> {
  constructor(props:CarouselProps) {
    super(props);
    const actionTaken = this.props.item.message.actionTaken;
    this.state = {isAlreadySelected:(actionTaken) ? true : false, trackIndex:0 }
    this.prevClicked = this.prevClicked.bind(this);
    this.nextClicked = this.nextClicked.bind(this)
    this.actionSelected = this.actionSelected.bind(this)

  }
  prevClicked() {

    if (this.state.trackIndex > 0) {
       this.setState({trackIndex: this.state.trackIndex - 1 })
     }
   }
  nextClicked() {
    if ((this.props.item as any).message?.payload.cards &&
        this.state.trackIndex <  (this.props.item as any).message?.payload.cards.length - 1) {

        this.setState({trackIndex: this.state.trackIndex + 1 })

    }
  }
  actionSelected(item:ActionInterface) {
    const messageId = this.props.item.message.uuid;
    const actionTaken = createActionTaken(ActionTakenType.Selected, item.id)

    this.props.messageHandler.actionTaken(messageId, actionTaken);
    // this.setState({selectTwo:true});
  }

  render() {
    const item:any = this.props.item;
    const cardsData:Array<CarouselPayloadCard> = item.message?.payload.cards;
    const actionTaken = this.props.item.message.actionTaken;

    let selectedActionId:string | undefined;
    if (actionTaken) {

      if (actionTaken.type == ActionTakenType.Selected) {
        selectedActionId = actionTaken.target;
      }
    }

    var cards:any = [];
    var dots:any = [];
    if (cardsData) {
      for (let i = 0; i < cardsData.length; i++) {
        const item = cardsData[i];
        cards.push(<Slide index={i} key={"slide_" + i}>
          <CarouselCard key={item.id} item={item} selectedId={selectedActionId} isActive={this.props.isActive} width={this.props.width} actionSelected={this.actionSelected} />
        </Slide>);

        dots.push(<Dot slide={i} >
          <svg height="10" width="10">
          <circle cx="5" cy="5" r="4" />
          </svg>
          </Dot>)
      }

      // cardsData.map((item) => <CarouselCard key={item.id} item={item} selectedId={selectedActionId} isActive={this.props.isActive} width={this.props.width} actionSelected={this.actionSelected} /> );
    } 
    const prevArrowIsHidden = (this.state.trackIndex > 0) ? false : true;
    const nextArrowClassIsHidden = (this.state.trackIndex < cardsData.length - 1) ? false: true;

    const trackStyle = {transform:"translateX(" + ((this.props.width * 0.1) - (this.state.trackIndex *  ((this.props.width * WIDTH_FACTOR) + 10) ) )+  "px)"}
    
    
    return <CarouselProvider
    naturalSlideWidth={this.props.width}
    naturalSlideHeight={125}
    totalSlides={cards.length}
    isIntrinsicHeight={true}
    className="scc-Carousel"
  >
    <Slider>
    {cards}
    </Slider>
    <ButtonBack className="">
      <CarouselArrow leftSide={true} isHidden={prevArrowIsHidden} onClick={this.prevClicked} />
</ButtonBack>
    <ButtonNext className=""> 
      <CarouselArrow leftSide={false} isHidden={nextArrowClassIsHidden}  onClick={this.nextClicked} /></ButtonNext>
      <div className="scc-carouselDots">
        
      
      <Dots  />

      </div>
  </CarouselProvider>;

    // return <div className="scc-Carousel">

    // <CarouselArrow leftSide={true} isHidden={prevArrowIsHidden} onClick={this.prevClicked} />
    // <CarouselArrow leftSide={false} isHidden={nextArrowClassIsHidden}  onClick={this.nextClicked} />
    //         <div className="scc-CarouselCardsTrack" style={trackStyle}>
    //           {cards}
    //         </div>
    //         <CarouselDots count={cardsData.length} index={this.state.trackIndex} />
    //       </div>;
  }
}
